import React from 'react'
import { compose } from 'recompose'
import { Button, Spin, message } from 'antd'
import { injectIntl, FormattedMessage } from 'react-intl'
import _get from 'lodash/get'
import useOmiseOffsite from '~/App/hooks/useOmiseOffsite'
import { Block } from '../styles'

const OmiseNetbank = compose(
  injectIntl
)(({ intl, registration, discounted, gatewayRate, gatewaySettings, systemFee, totalSystemFee, itemsDiscounted }) => {
  const publicKey = _get(gatewaySettings, 'publicKey', process.env.REACT_APP_OMISE_PUBLIC_KEY) || process.env.REACT_APP_OMISE_PUBLIC_KEY
  const totalAmount = discounted + itemsDiscounted
  const fee = Math.round(gatewayRate * discounted * 100) / 100
  const finalAmount = totalAmount + fee

  const [omiseLoaded, paymentLoading, pay] = useOmiseOffsite('omise_netbank', publicKey, (err) => {
    const { graphQLErrors } = err
    if (graphQLErrors) {
      graphQLErrors.forEach(error => {
        message.error(intl.formatMessage({ id: `api.${error.message}` }))
      })
    } else if (err.message) {
      message.error(err.message)
    } else {
      message.error(err)
    }
  })
  return <Block>
    <div className="title">
      <FormattedMessage id="paymentMethod.omise_netbank" />
    </div>
    {omiseLoaded ? <React.Fragment>
      <div>
        {systemFee
          ? <React.Fragment>
            <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(discounted - totalSystemFee)
            }} />
            <FormattedMessage id="app.processingFeeBaht" defaultMessage="Processing Fee {amount} Baht" tagName="div" values={{
              amount: intl.formatNumber(totalSystemFee)
            }} />
          </React.Fragment>
          : <FormattedMessage id="app.entryFeeBaht" defaultMessage="Entry Fee {amount} Baht" tagName="div" values={{
            amount: intl.formatNumber(discounted)
          }} />
        }
        <FormattedMessage id="app.paymentProcessingFeeBaht" defaultMessage="Processing Fee" tagName="div" values={{
          amount: intl.formatNumber(fee)
        }} />
        <FormattedMessage id="app.bankProcessingFee" />
        {itemsDiscounted > 0 && <FormattedMessage id="app.itemsAmountBaht" defaultMessage="Extra Products {amount} Baht" tagName="div" values={{
          amount: intl.formatNumber(itemsDiscounted)
        }} />}
        <FormattedMessage id="app.payBaht" tagName="div" values={{
          amount: intl.formatNumber(finalAmount)
        }} />
      </div>
      <Button
        type="primary"
        onClick={e =>
          pay('internet_banking_bay', registration, {
            amount: finalAmount
          })}
        loading={paymentLoading}
        className="paymentButton"
      >
      KrugsriOnline
      </Button>
      <Button
        type="primary"
        onClick={e =>
          pay('internet_banking_bbl', registration, {
            amount: finalAmount
          })}
        loading={paymentLoading}
        className="paymentButton"
      >
      Bualuang iBanking
      </Button>
      <Button
        type="primary"
        onClick={e =>
          pay('internet_banking_ktb', registration, {
            amount: finalAmount
          })}
        loading={paymentLoading}
        className="paymentButton"
      >
      KTB Netbank
      </Button>
      <Button
        type="primary"
        onClick={e =>
          pay('internet_banking_scb', registration, {
            amount: finalAmount
          })}
        loading={paymentLoading}
        className="paymentButton"
      >
      SCBEasy
      </Button>
    </React.Fragment>
      : <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>}
  </Block>
})

export default OmiseNetbank



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseNetbank/OmiseNetbank.js